<nz-header>
    <div class="header-left">
        <div class="logo" (click)="onNavigateToHome()">
            <app-bridge-hire-icon></app-bridge-hire-icon>
            <strong>ChicagoMedTechSalaries</strong>
        </div>
        <div class="divider"></div>
        <div nz-menu nzTheme="light" nzMode="horizontal" class="menu">
            @for (item of navigationItems(); track item.label) {
            <li nz-menu-item routerLink="{{ item.routerLink }}">{{ item.label }}</li>
            }
            <li nz-menu-item nz-dropdown [nzDropdownMenu]="browseMenu"
                nzOverlayClassName="header-dropdown browse-dropdown" nzPlacement="bottomCenter">
                <span>Browse <span nz-icon nzType="down" style="font-size: 10px; margin-left: 4px;"></span></span>
            </li>
            <nz-dropdown-menu #browseMenu="nzDropdownMenu">
                <ul nz-menu>
                    @for (item of subNavigationItems; track item.label) {
                    <li nz-menu-item routerLink="{{ item.routerLink }}">{{ item.label }}</li>
                    }
                </ul>
            </nz-dropdown-menu>

            <li nz-menu-item routerLink="/about">About</li>

        </div>
    </div>

    <div class="btn-group">
        <app-notification-badge></app-notification-badge>
        <nz-avatar nzIcon="user" nz-dropdown [nzDropdownMenu]="menu" nzOverlayClassName="header-dropdown"></nz-avatar>
        <button nz-button nzType="text" class="mobile-menu-btn" (click)="openMobileMenu()">
            <span nz-icon nzType="menu" nzTheme="outline"></span>
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
                @for (item of dropDownMenuItems(); track item.label) {
                <li nz-menu-item routerLink="{{ item.routerLink }}">{{ item.label }}</li>
                }
                <li nz-menu-item>
                    <a href="mailto:support@chicagomedtechsalaries.com">Contact Support</a>
                </li>
                @if(isAuthenticated()){
                <li nz-menu-item (click)="logout()">
                    <span>Sign Out</span>
                </li>
                }
                @else{
                <li nz-menu-item (click)="navigateToLogin()">
                    <span>Sign In</span>
                </li>
                }
            </ul>
        </nz-dropdown-menu>
    </div>
</nz-header>

<nz-drawer [nzClosable]="true" [nzVisible]="mobileMenuVisible()" nzPlacement="right" nzTitle="Navigation"
    (nzOnClose)="closeMobileMenu()">
    <ng-container *nzDrawerContent>
        <ul nz-menu nzMode="inline" class="mobile-menu-list">
            <li nz-menu-item routerLink="/notifications" (click)="closeMobileMenu()" class="drawer-notifications-item">
                <div class="notification-mobile-drawer-item">
                    <app-notification-badge></app-notification-badge>
                    <span class="drawer-notifications-text">Notifications</span>
                </div>
            </li>
            @for (item of navigationItems(); track item.label) {
            <li nz-menu-item routerLink="{{ item.routerLink }}" (click)="closeMobileMenu()">{{
                item.label }}</li>
            }
            <li nz-submenu nzTitle="Browse">
                <ul>
                    @for (item of subNavigationItems; track item.label) {
                    <li nz-menu-item routerLink="{{ item.routerLink }}" (click)="closeMobileMenu()">{{ item.label }}
                    </li>
                    }
                </ul>
            </li>
            <li nz-submenu nzTitle="Profile">
                <ul>
                    @for (item of dropDownMenuItems(); track item.label) {
                    <li nz-menu-item routerLink="{{ item.routerLink }}" (click)="closeMobileMenu()">{{ item.label }}
                    </li>
                    }
                    <li nz-menu-item (click)="closeMobileMenu()">
                        <a href="mailto:support@chicagomedtechsalaries.com">Contact Support</a>
                    </li>
                    @if(isAuthenticated()){
                    <li nz-menu-item (click)="logout(); closeMobileMenu()">
                        <span>Sign Out</span>
                    </li>
                    }
                    @else{
                    <li nz-menu-item (click)="navigateToLogin(); closeMobileMenu()">
                        <span>Sign In</span>
                    </li>
                    }
                </ul>
            </li>
            <li nz-menu-item routerLink="/about" (click)="closeMobileMenu()">About</li>
        </ul>
    </ng-container>
</nz-drawer>